'use client';

import { safeLocalStorage } from '@/lib/safeLocalStorage';

export function getValidRecentSearches() {
  // This is to ensure that any Local Storage "schema" changes don't break releases
  const item = safeLocalStorage.getItem('recent-searches');
  const fallbackArr: { name?: string; slug?: string }[] = [];

  function resetRecentSearches() {
    safeLocalStorage.setItem('recent-searches', JSON.stringify(fallbackArr));
  }

  if (!item) {
    resetRecentSearches();
    return fallbackArr;
  }

  try {
    const parsed = JSON.parse(item);

    if (!Array.isArray(parsed)) {
      resetRecentSearches();
      return fallbackArr;
    }

    const isValid = parsed.every((obj) => {
      const keys = Object.keys(obj);
      if (
        keys.length !== 2 ||
        !keys.includes('name') ||
        !keys.includes('slug')
      ) {
        return false;
      }
      // Check if both values are strings
      return typeof obj.name === 'string' && typeof obj.slug === 'string';
    });

    if (!isValid) {
      resetRecentSearches();
      return fallbackArr;
    }

    return parsed;
  } catch (err) {
    resetRecentSearches();
    console.error(err);
    return fallbackArr;
  }
}
